import $ from 'jquery'

export class BannerTopGrid {
  constructor() {
    this.$bannerTop = $('.banner-top')
    this.$bannerTopContent = $('.banner-top-content')

    if (this.$bannerTop.length === 0) {
      return
    }

    setTimeout(this.fixBannerTopHeight.bind(this), 150)
  }

  fixBannerTopHeight() {
    this.$bannerTop.css({'height': this.$bannerTopContent.outerHeight(true) + 'px'})
  }
}
